import classes from './CustomInput.module.scss'

import eye from '../../../assets/icons/eye.svg'
import eye_crossed from '../../../assets/icons/eye_crossed.svg'


import { useState } from 'react'

const CustomTextArea = (props) => {

    const value = props.value || '';
    const status = props.status

    const [type, setType] = useState(props.type ? props.type : 'text')

    let style = [classes.container].join(' ')
    const red = [classes.container,classes.red].join(' ')
    const blue = [classes.container,classes.blue].join(' ')
    const green = [classes.container,classes.green].join(' ')

    if(value && value.length > 0) {
        if(status === 'error') style = red;
        if(status === 'success') style = blue;
        if(status === 'pending') style = blue;
    }

    const togglePasswordType = () => {
        if(type !== 'password') setType('password')
        else {
            setType('text')
        }
    }

    return (
        <div className={style+" "+props.className} style={props.style}>
            <div className={classes.icon}>
                {(props.image_src)?<img src={props.image_src} alt=''/>:""}
                {(props.inline_label)?props.inline_label:""}</div>
            <textarea placeholder={props.placeholder} name={props.name} step={props.step} type={type} onChange={props.onChange}  required={props.required} disabled={props.disabled}>{value}</textarea>
            {props.type === 'password' && <div className={classes.icon} style={{width: 22, height: 22, cursor: 'pointer'}}><img src={type === "password"?eye:eye_crossed} alt='password_toggle' onClick={togglePasswordType}/></div>}
        </div>
    )
}

export default CustomTextArea